export enum EntidadParteDiario {
    TanqueServicio,
    TanqueTelemedicion,
    Expendedora,
    EquipoFijo,
    SistemasSeguridad
  }